<template>
  <div id="mapi">
    <v-main>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 class="ma-1" row>
            <v-flex sm2>
              <h2 class="mt-n3">{{$t("Storage Map")}}</h2>
            </v-flex>
            <v-flex xs6>
              <v-layout align-bottom justify-center>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="changeColor"
                      color="primary"
                      :disabled = "loading || !selectedBox"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                    <v-icon color="white">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t("Change color of marked storage")}}</span>
                </v-tooltip>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="moveControl"
                      color="primary"
                      :disabled = "loading || !selectedBox"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                    <v-icon color="white">mdi-arrow-all</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t("Enable move on marked storage")}}</span>
                </v-tooltip>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="showStorageInfo"
                      color="primary"
                      :disabled = "loading || !selectedBox"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                    <v-icon color="white">mdi-information-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t("Storage information")}}</span>
                </v-tooltip>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="copyStaticMapUrl"
                      color="primary"
                      :disabled = "loading"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                    <v-icon color="white">link</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t("Copy static map link")}}</span>
                </v-tooltip>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="refreshStoragesClick"
                      color="primary"
                      :disabled = "loading"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                    <v-icon color="white">refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t("Refresh")}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="zoom"
                      color="primary"
                      :disabled = "loading"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                    <v-icon color="white">add</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t("Zoom in")}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="unZoom"
                      color="primary"
                      :disabled = "loading"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                    <v-icon color="white">remove</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t("Zoom out")}}</span>
                </v-tooltip>
              </v-layout>
            </v-flex>
            <v-flex xs2>
              <v-text-field class="ml-2 mr-2 mt-n2"
                    v-model="filters.storageSearchText"
                    append-icon="mdi-magnify"
                    :label="$t('Storage')"
                    solo
                    hide-details
                    shrink
                    @input="handleInput"
                  ></v-text-field>
              </v-flex>
              <v-flex xs2><v-select class="mt-n2" :disabled = "loading" hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          </v-flex>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        </v-layout>
        <!-- <div>:: {{ info1 }}</div>
        <div>:: {{ info2 }}</div>
        <div>:: {{ info3 }}</div> -->
        <v-layout row wrap>
          <div v-if="loading"></div>
        </v-layout>
          <div id="map"></div>
          <v-layout row wrap>

              <v-dialog
                v-model="storageRegsDialog" max-width="900" >
                <v-card>
                  <v-card-title class="headline">{{$t("Info")}}</v-card-title>
                    <template>
                      <v-flex xs12 row>
                        <v-flex xs7 sm7 class="pl-5 ma-3 font-weight-bold">
                          <v-flex style="font-size: 16px">{{$t("Storage")}}: {{getHeader()}} </v-flex>
                        </v-flex>
                      <v-flex xs4 sm4 class="pa-1 ma-3 font-weight-bold">
                          <v-flex style="font-size: 16px; text-align:right">{{(sumWeight).toLocaleString()}} kg</v-flex>
                      </v-flex>
                    </v-flex>
                    <v-layout column style="height: 70vh">
                      <v-flex md12 style="overflow: auto">
                        <v-data-table hide-default-footer dense
                          :headers="translatedHeaders()"
                          :items="registrations"
                          :items-per-page="300"
                          class="elevation-1">
                          <template v-slot:[`item.CreatedDate`]="{ item }">
                            <v-flex class="font-weight-bold align-content-end">
                              {{ getDate(item.CreatedDate) }}
                            </v-flex>
                          </template>
                          <template v-slot:[`item.RegistrationNo`]="{ item }">
                            <v-flex class="font-weight-bold align-content-end">
                              {{ item.RegistrationNo }}
                            </v-flex>
                          </template>
                          <template v-slot:[`item.ArticleNo`]="{ item }">
                            <v-flex class="font-weight-bold align-content-end">
                              {{ item.ArticleNo }}
                            </v-flex>
                          </template>
                          <template v-slot:[`item.ArticleName`]="{ item }">
                            <v-flex class="font-weight-bold">
                             {{ item.ArticleName }}
                            </v-flex>
                          </template>
                          <template v-slot:[`item.TransferLocation`]="{ item }">
                            <v-flex class="font-weight-bold">
                              {{ item.TransferLocation }}
                            </v-flex>
                          </template>
                          <template v-slot:[`item.TransferFromLocation`]="{ item }">
                            <v-flex class="font-weight-bold">
                              {{ item.TransferFromLocation }}
                            </v-flex>
                          </template>
                          <template v-slot:[`item.CreatedBy`]="{ item }">
                            <v-flex class="font-weight-bold align-content-end">
                              {{ item.CreatedBy }}
                            </v-flex>
                          </template>
                          <template v-slot:[`item.WeightNet`]="{ item }">
                            <v-flex class="font-weight-bold text-xs-right" :style="fieldColor(item)">
                              <div class="d-flex justify-end">{{ (item.WeightNet).toLocaleString()  }}</div>
                            </v-flex>
                          </template>
                          <template slot="body.append">
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                    <template>
                      <v-btn v-if="showRegUpBtn" ref="yesButton" color="success" @click="storageRegsDialog = false; JumpToScanMobile('Up')">{{$t("New registration (count Up)")}}</v-btn>
                      <v-btn v-if="showRegDownBtn" ref="yesButton" color="success" @click="storageRegsDialog = false; JumpToScanMobile('Down')">{{$t("New registration (count Down)")}}</v-btn>
                      <v-btn v-if="showRegBtn" ref="yesButton" color="success" @click="storageRegsDialog = false; JumpToScanMobile()">{{$t("New registration")}}</v-btn>
                      <v-btn ref="noButton" color="primary" @click="storageRegsDialog = false" autofocus>{{$t("Close")}}</v-btn>
                    </template>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="pickColorDialog" max-width="400" >
                <v-card>
                  <v-card-title class="headline">{{$t("Color")}}?</v-card-title>
                  <template>
                    <v-card-text class="font-weight-bold">{{$t("Pick the color of the storage")}} {{getHeader()}} </v-card-text>
                  </template>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                      <template>
                        <v-btn ref="greenButton" color="success" @click="pickColorDialog = false; colorPicked('green')" autofocus>{{$t("Green")}}</v-btn>
                        <v-btn ref="yellowButton" color="warning" @click="pickColorDialog = false; colorPicked('yellow')" >{{$t("Yellow")}}</v-btn>
                        <v-btn ref="redButton" color="error" @click="pickColorDialog = false; colorPicked('red')" >{{$t("Red")}}</v-btn>
                        <v-btn ref="blueButton" color="primary" @click="pickColorDialog = false; colorPicked('blue')" >{{$t("Blue")}}</v-btn>
                      </template>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

          </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import filters from '@/core/mixins/common-filters'
import * as StorageMap from '@/modules/storage-map/storage-map'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
// import * as Admin from '@/core/admin'
import * as DateUtil from '@/core/date'
import * as Security from '@/core/security'
import Konva from 'konva'
import _ from 'lodash' // clone

export default {
  mixins: [filters],
  name: 'storage-map',
  components: { },
  data () {
    return {
      filters: {
        storageSearchText: ''
      },
      info1: 'info1',
      info2: 'info2',
      info3: 'info3',
      loading: false,
      registrations: [],
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      storageRegsDialog: false,
      sumWeight: 0,
      redirectToScanMobile: 'create-scan-mobile-registration',
      acceptedFileTypes: ['png', 'jpg'],
      selectedBox: null,
      allBoxes: [],
      layerStorage: null,
      image: null,
      storages: null,
      searchStorages: null,
      originalStorages: null,
      chosenStorage: null,
      mapStage: null,
      sceneWidth: 4000,
      sceneHeight: 2828,
      circleRadius: 42,
      strokeWidth: 12,
      strokeWidthCircle: 8,
      fontSize: 32,
      trans: null,
      pickColorDialog: false,
      zoomScale: 1,
      layerScale: 1,
      showRegBtn: true,
      showRegUpBtn: false,
      showRegDownBtn: false,
      headers: [
        { text: 'Date', value: 'CreatedDate' },
        { text: 'Reg No', value: 'RegistrationNo' },
        { text: 'Article No', value: 'ArticleNo' },
        { text: 'Name', value: 'ArticleName' },
        { text: 'Moved to storage', value: 'TransferLocation' },
        { text: 'Moved from storage', value: 'TransferFromLocation' },
        { text: 'User', value: 'CreatedBy' },
        { text: 'Kg', value: 'WeightNet' }
      ],
      item: {
        FileItems: []
      }
    }
  },
  watch: {
  },
  methods: {
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }

      if (this.facilityNo !== null && this.facilityNo !== '') LocalStorage.save('facilityNo', this.facilityNo)
      this.image = null
      this.loading = true
      await this.loadFacilityImage()
      await this.loadStorageMap()
      this.loading = false
    },
    async handleInput (value) {
      if (value === '') {
        this.storages = this.originalStorages
      }
      await this.loadStorageBoxes(this.storages.filter(item => item.No.includes(value)))
    },
    async copyStaticMapUrl () {
      var domain = (new URL(document.URL))
      var staticUrl = /* 'https://' + */ domain.hostname + '/storage-staticmap?facility=' + this.facilityNo + '&corpName=' + Security.user.corporation
      await navigator.clipboard.writeText(staticUrl)
      this.$root.$message.showSuccess(staticUrl + ' ' + this.$t('copied to clipboard'))
    },
    async HandleNewBoxes (boxes) {
      const T1X = 450
      const T1Y = 207
      const T2X = 64
      const T2Y = 203
      const B1X = 65
      const B1Y = 77
      const B2X = 453
      const B2Y = 80
      var offset = 0
      boxes.forEach((box) => {
        if (box.T1X === 0) {
          // handle a max
          if (box.B2Y + offset > 2828) {
            offset -= 160
          }
          box.T1X = T1X
          box.T1Y = T1Y + offset
          box.T2X = T2X
          box.T2Y = T2Y + offset
          box.B1X = B1X
          box.B1Y = B1Y + offset
          box.B2X = B2X
          box.B2Y = B2Y + offset
          offset += 160
        }
      })
    },
    async loadFacilityImage () {
      if (this.facilityNo !== null && this.facilityNo !== '') {
        // var id = this.facilities.find(o => o.text === this.facilityNo)
        // const res = await Admin.loadFacility(id.id)
        const res = await StorageMap.loadFacilityDataUser({ facilityNo: this.facilityNo, corpName: Security.user.corporation })
        if (!res.failed) {
          this.details = res.data.Details
          const storageMapDetail = this.details.find(o => o.Name === 'StorageMapImage')
          if (storageMapDetail !== undefined) {
            if (storageMapDetail?.Data3AsBase64 != null) {
              var o = 'data:image/jpeg;base64,' + storageMapDetail?.Data3AsBase64
              this.image = o
            }
          }

          this.showRegBtn = res.data.Details.find(d => d.Name === 'newRegBtn')?.Value === 'true'
          this.showRegUpBtn = res.data.Details.find(d => d.Name === 'newRegUpBtn')?.Value === 'true'
          this.showRegDownBtn = res.data.Details.find(d => d.Name === 'newRegDownBtn')?.Value === 'true'
        }
      }
    },
    async loadStorageMap () {
      if (this.facilityNo !== null && this.facilityNo !== '') {
        var res = await StorageMap.loadStorageMaps(this.facilityNo)
        if (!res.failed) {
          this.storages = res.data
          await this.HandleNewBoxes(this.storages)
          this.loadStorageBoxes(this.storages)
          this.originalStorages = this.storages
        }
      }
    },
    async JumpToScanMobile (params) {
      console.log('pip jump', params)
      if (this.selectedBox?.storage?.No) await this.onJumpToScanMobile('123', this.facilityNo, this.selectedBox.storage.No, params)
    },
    async onJumpToScanMobile (vehicle, facility, storageNo, storageType) {
      this.$router.push({ name: this.redirectToScanMobile, params: { vehicle: vehicle, facility: facility, pendingVehicles: [], storage: storageNo, sType: storageType } })
    },
    translatedHeaders () {
      return this.headers.map(header => {
        const h = { ...header }
        h.text = this.$t(header.text)
        return h
      })
    },
    zoom () {
      this.zoomMap(true)
    },
    unZoom () {
      this.zoomMap(false)
    },
    zoomMap (zoomIn) {
      if (this.layerScale > 5 && zoomIn) return
      if (this.layerScale < 0.5 && !zoomIn) return
      this.layerScale = zoomIn ? this.layerScale / 0.7 : this.layerScale * 0.7
      this.updateMapLayer()
    },
    updateMapLayer () {
      this.mapLayer.scale({ x: this.layerScale, y: this.layerScale })
      if (this.selectedBox) {
        this.selectedBox.strokeWidth(this.strokeWidth / this.layerScale)
        if (this.selectedBox.cir1 && this.selectedBox.cir1.draggable()) {
          this.selectedBox.cir1.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir1.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
        if (this.selectedBox.cir2 && this.selectedBox.cir2.draggable()) {
          this.selectedBox.cir2.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir2.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
        if (this.selectedBox.cir3 && this.selectedBox.cir3.draggable()) {
          this.selectedBox.cir3.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir3.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
        if (this.selectedBox.cir4 && this.selectedBox.cir4.draggable()) {
          this.selectedBox.cir4.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir4.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
      }
    },
    fieldColor (field) {
      // Show headers as grey (past), blue (today) or future (black)
      var color = field.WeightNet < 0 ? 'color:red'
        : 'color:black'
      return color
    },
    getHeader () {
      // console.log('header', this.selectedBox?.storage, this.storageName, this.selectedBox?.storage?.No, this.selectedBox?.storage?.Name)
      if (this.selectedBox?.storage) {
        if (this.storageName) return this.selectedBox?.storage?.No + ' - ' + this.storageName
        if (this.selectedBox?.storage?.Name) return this.selectedBox?.storage?.No + ' - ' + this.selectedBox?.storage?.Name
        return this.selectedBox?.storage?.No + ' - ' + this.selectedBox?.storage?.Name
      }
      return 'Unkown'
    },
    async fitStageIntoParentContainer () {
      var container = document.querySelector('#map')

      if (!this.mapStage || !container) return

      // now we need to fit stage into parent container
      var containerWidth = container.offsetWidth
      // but we also make the full scene visible
      // so we need to scale all objects on canvas
      var scale = containerWidth / this.sceneWidth
      if (this.refreshingPreScale) scale = this.refreshingPreScale
      this.mapStage.width(this.sceneWidth * scale)
      this.mapStage.height(this.sceneHeight * scale)
      this.mapStage.scale({ x: scale, y: scale })
      this.zoomScale = scale
    },
    async loadStorageBoxes (storages) {
      const self = this
      this.mapStage = new Konva.Stage({
        container: 'map',
        width: window.innerWidth,
        height: window.innerHeight,
        opacity: 1,
        draggable: false
      })

      this.mapGroup = new Konva.Group({ draggable: true, position: { x: 0, y: 0 } })
      this.mapLayer = new Konva.Layer()
      this.mapLayer.add(this.mapGroup)
      this.mapStage.add(this.mapLayer)

      var imageObj = new Image()
      imageObj.onload = function () {
        self.mapImg = new Konva.Image({
          x: 0,
          y: 0,
          image: imageObj,
          width: self.sceneWidth,
          height: self.sceneHeight
        })
        self.mapLayer.add(self.mapImg)
        self.mapGroup.add(self.mapImg)
        self.mapImg.moveToBottom()
      }
      imageObj.src = this.image
      await this.fitStageIntoParentContainer()
      this.updateMapLayer()

      this.allBoxes = []
      for (let i = 0; i < storages.length; i++) {
        var storage = storages[i]
        if (storage.No !== '') {
          var box = this.newBox(storage, self)
          this.allBoxes.push(box)
          var group = new Konva.Group({ draggable: false, position: { x: 0, y: 0 } })
          box.group = group
          this.mapLayer.add(box, box.cir1, box.cir2, box.cir3, box.cir4, box.tooltip)
          group.add(box, box.cir1, box.cir2, box.cir3, box.cir4, box.tooltip) // box must be first
          group.on('dragend', function (e) {
            if (e.target.draggable && e.target.children && e.target.children.length > 0) {
              const box = e.target.children[0] // We assume box is first element
              box.dirty = true
            }
          })

          this.mapGroup.add(group)
          self.centerToolTip(box)
        }
      }

      this.mapGroup.on('dragmove', function (e) {
        self.adjustPosition()
      })

      this.mapLayer.draw()
    },
    newBox (storage, self) {
      // Txx and Byy are just points, we don't know by name what is upper left corner.
      // To be able to draw/scale correct we need to know all corners
      var correctPoints = this.convertToPoints(storage)

      var box = new Konva.Line({
        points: correctPoints,
        fill: this.getColor(storage),
        stroke: 'rgba(0,0,0)',
        strokeWidth: this.strokeWidth / this.layerScale,
        draggable: false,
        closed: true,
        opacity: 0.5,
        dirty: false
      })
      box.storage = storage
      this.newCircle(1, box, this)
      this.newCircle(2, box, this)
      this.newCircle(3, box, this)
      this.newCircle(4, box, this)
      this.newText(box)
      this.centerToolTip(box)

      box.on('pointerclick', async function () {
        const wasEnabled = this.strokeEnabled()
        self.allBoxes.forEach((box2) => {
          box2.strokeEnabled(false)
          if (box2.group) box2.group.draggable(false)
        })
        await self.disableMove()
        self.moving = false
        if (!wasEnabled) {
          this.strokeEnabled(true)
          self.selectedBox = this
          self.updateMapLayer()
        } else {
          self.selectedBox = undefined
        }
      })
      box.strokeEnabled(false)

      return box
    },
    newText (box) {
      var tooltip = new Konva.Label({
        x: 0,
        y: 0,
        listening: false
      })
      tooltip.add(
        new Konva.Tag({
          fill: 'black',
          pointerDirection: 'down',
          pointerWidth: 2,
          pointerHeight: 2,
          lineJoin: 'round',
          shadowColor: 'black',
          shadowBlur: 2,
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowOpacity: 0.0,
          opacity: 0.0 // We hide it. Tag is used for easy center and in the future possible visible
        })
      )
      const text = new Konva.Text({
        text: box.storage.No,
        offsetY: -10,
        fontFamily: 'Calibri',
        fontSize: this.fontSize,
        fontStyle: '',
        padding: 8,
        fill: '#FFFFFF',
        shadowForStrokeEnabled: true,
        shadowBlur: 3,
        shadowOffsetX: 0.5,
        shadowOffsetY: 0.5,
        shadowOpacity: 1
        /* stroke: '#0007',
        strokeEnabled: true,
        strokeWidth: 1 */
      })
      tooltip.add(text)
      box.tooltip = tooltip
      box.text = text
    },
    newCircle (corner, box, self) {
      const hexColorCirleStroke = 'rgba(255,255,255,0.9)'
      // if (corner === 2) hexColorCirleStroke = 'rgba(255,0,0,0.9)'
      // if (corner === 3) hexColorCirleStroke = 'rgba(0,255,0,0.9)'
      // if (corner === 4) hexColorCirleStroke = 'rgba(0,0,255,0.9)'
      const hexColorCircleShadow = 'rgba(0,0,0,0.5)'
      const circleShadowOffset = { x: 4, y: 4 }
      const cicleShadowOpacity = 0.5
      const circleShadowBlur = 5
      let x = 0
      let y = 0
      if (corner === 1) { x = box.points()[0]; y = box.points()[1] }
      if (corner === 2) { x = box.points()[2]; y = box.points()[3] }
      if (corner === 3) { x = box.points()[4]; y = box.points()[5] }
      if (corner === 4) { x = box.points()[6]; y = box.points()[7] }
      const circle = new Konva.Circle({
        x: x,
        y: y,
        radius: 0,
        stroke: hexColorCirleStroke,
        shadowColor: hexColorCircleShadow,
        shadowOffset: circleShadowOffset,
        shadowOpacity: cicleShadowOpacity,
        shadowBlur: circleShadowBlur,
        strokeWidth: this.strokeWidthCircle / this.layerScale,
        draggable: false,
        opacity: 1,
        box: box
      })
      if (corner === 1) { box.cir1 = circle }
      if (corner === 2) { box.cir2 = circle }
      if (corner === 3) { box.cir3 = circle }
      if (corner === 4) { box.cir4 = circle }
      circle.on('dragmove', function (e) {
        const cir = e.target
        const box = e.target?.attrs?.box
        if (cir && box && cir === box.cir1) { box.points()[0] = cir.position().x; box.points()[1] = cir.position().y }
        if (cir && box && cir === box.cir2) { box.points()[2] = cir.position().x; box.points()[3] = cir.position().y }
        if (cir && box && cir === box.cir3) { box.points()[4] = cir.position().x; box.points()[5] = cir.position().y }
        if (cir && box && cir === box.cir4) { box.points()[6] = cir.position().x; box.points()[7] = cir.position().y }
        self.centerToolTip(box)
        box.dirty = true
      })

      return circle
    },
    centerToolTip (box) {
      if (!box) return
      let factor = 1
      if (box.group) {
        factor = Math.max(0.70, Math.min(2, box.group.getClientRect().width / (200 * this.zoomScale * this.layerScale)))
      }
      box.text.fontSize(this.fontSize * factor)
      box.tooltip.x(this.getSizeX2(box))
      box.tooltip.y(this.getSizeY2(box) + box.text.fontSize() / 2)
    },
    convertToPoints (storage) {
      // T1X is the smallest (we default assume)
      var res = [storage.T1X, storage.T1Y,
        storage.T2X, storage.T2Y,
        storage.B1X, storage.B1Y,
        storage.B2X, storage.B2Y]
      if (storage.T2X < storage.T1X && storage.T2X < storage.B1X && storage.T2X < storage.B2X) {
        // T2X is the smallest
        res = [storage.T2X, storage.T2Y,
          storage.B1X, storage.B1Y,
          storage.B2X, storage.B2Y,
          storage.T1X, storage.T1Y]
      } else if (storage.B1X < storage.T1X && storage.B1X < storage.T2X && storage.B1X < storage.B2X) {
        // B1X is the smallest
        res = [storage.B1X, storage.B1Y,
          storage.B2X, storage.B2Y,
          storage.T1X, storage.T1Y,
          storage.T2X, storage.T2Y]
      } else if (storage.B2X < storage.T1X && storage.B2X < storage.T2X && storage.B2X < storage.B1X) {
        // B2X is the smallest
        res = [storage.B2X, storage.B2Y,
          storage.T1X, storage.T1Y,
          storage.T2X, storage.T2Y,
          storage.B1X, storage.B1Y]
      }
      return res
    },
    showInfo () {
      // this.adjustPosition()
      // var box1 = this.allBoxes[0]
      // if (box1) {
      //   this.info1 = 'box points: ' + JSON.stringify(box1.points().map(e => e.toFixed(0))) + '  layerScale: ' + this.layerScale.toFixed(4) + ' ZoomScale: ' + this.zoomScale.toFixed(4) + ' y:' + (-1 * (this.sceneHeight - (this.sceneHeight / this.layerScale)))
      //   this.info2 = 'box abs pos: ' + box1.absolutePosition().x.toFixed() + ',' + box1.absolutePosition().y.toFixed() +
      //     '  box pos: ' + box1.position().x.toFixed() + ',' + box1.position().y.toFixed() +
      //     '  mapImg abs pos:' + this.mapImg?.absolutePosition().x.toFixed() + ',' + this.mapImg?.absolutePosition().y.toFixed() +
      //     '  mapImg pos:' + this.mapImg?.position().x.toFixed() + ',' + this.mapImg?.position().y.toFixed() +
      //     '  mapImg size: ' + this.mapImg?.width().toFixed() + ',' + this.mapImg?.height().toFixed()
      //   this.info3 = 'group: rect: ' + box1.group?.getClientRect().x.toFixed() + ',' + box1.group?.getClientRect().y.toFixed() +
      //     '  (size:' + box1.group?.getClientRect().width.toFixed() + ',' + box1.group?.getClientRect().height.toFixed() + ') ' +
      //   //          '  group0 pos: ' + this.group0.position().x.toFixed() + ',' + this.group0.position().y.toFixed() +
      //   //          '  (size: ' + this.group0.getClientRect().width.toFixed() + ',' + this.group0.getClientRect().height.toFixed() + ')' +
      //     '  stage size: ' + this.mapStage.width() + ',' + this.mapStage.height()
      // } else {
      //   this.info1 = 'box undefined'
      // }
    },
    adjustPosition () {
      if (this.mapGroup) {
        this.mapGroup.x(Math.min(this.mapGroup.x(), 0))
        this.mapGroup.y(Math.min(this.mapGroup.y(), 0))
        this.mapGroup.x(Math.max(this.mapGroup.x(), Math.min(0, -1 * (this.sceneWidth - (this.sceneWidth / this.layerScale * 0.5)))))
        this.mapGroup.y(Math.max(this.mapGroup.y(), Math.min(0, -1 * (this.sceneHeight - (this.sceneHeight / this.layerScale * 0.5)))))
      }
    },
    getColor (storage) {
      var res = '#00FF00'
      switch (storage.Color) {
        case 2:
          res = '#FFFF00'
          break
        case 3:
          res = '#FF0000'
          break
        case 4:
          res = '#0000FF'
      }
      return res
    },
    getSizeX2 (box) {
      return (Math.max(box.cir1.attrs.x, box.cir2.attrs.x, box.cir3.attrs.x, box.cir4.attrs.x) - Math.min(box.cir1.attrs.x, box.cir2.attrs.x, box.cir3.attrs.x, box.cir4.attrs.x)) / 2 + Math.min(box.cir1.attrs.x, box.cir2.attrs.x, box.cir3.attrs.x, box.cir4.attrs.x)
    },
    getSizeY2 (box) {
      return (Math.max(box.cir1.attrs.y, box.cir2.attrs.y, box.cir3.attrs.y, box.cir4.attrs.y) - Math.min(box.cir1.attrs.y, box.cir2.attrs.y, box.cir3.attrs.y, box.cir4.attrs.y)) / 2 + Math.min(box.cir1.attrs.y, box.cir2.attrs.y, box.cir3.attrs.y, box.cir4.attrs.y)
    },
    getDate (date) {
      return DateUtil.getDateTime(date)
    },
    async showStorageInfo () {
      if (!this.selectedBox || !this.selectedBox.storage) return
      this.storageName = ''
      var regs = await StorageMap.loadStorageRegs(this.selectedBox.storage.StorageId)
      if (!regs.failed) {
        await this.disableMove()
        this.moving = false
        if (regs.data?.Regs) {
          this.registrations = regs.data.Regs
          this.sumWeight = regs.data.RegSum
          this.storageName = regs.data.StorageName
        } else {
          this.registrations = []
          this.sumWeight = 0
        }
        this.storageRegsDialog = true
      }
    },
    async moveControl () {
      if (this.moving) {
        await this.disableMove()
        this.moving = false
      } else {
        await this.enableMove()
        this.moving = true
      }
    },
    async enableMove () {
      if (this.selectedBox) {
        this.selectedBox.group.draggable(true)
        this.selectedBox.strokeWidth(this.strokeWidth / this.layerScale)
        if (this.selectedBox.cir1) {
          this.selectedBox.cir1.draggable(true)
          this.selectedBox.cir1.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir1.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
        if (this.selectedBox.cir2) {
          this.selectedBox.cir2.draggable(true)
          this.selectedBox.cir2.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir2.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
        if (this.selectedBox.cir3) {
          this.selectedBox.cir3.draggable(true)
          this.selectedBox.cir3.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir3.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
        if (this.selectedBox.cir4) {
          this.selectedBox.cir4.draggable(true)
          this.selectedBox.cir4.radius(this.circleRadius / this.layerScale)
          this.selectedBox.cir4.strokeWidth(this.strokeWidthCircle / this.layerScale)
        }
      }
    },
    async disableMove () {
      if (this.selectedBox && this.selectedBox.group) {
        this.selectedBox.group.draggable(false)
        if (this.selectedBox.cir1) {
          this.selectedBox.cir1.draggable(false)
          this.selectedBox.cir1.radius(0)
        }
        if (this.selectedBox.cir2) {
          this.selectedBox.cir2.draggable(false)
          this.selectedBox.cir2.radius(0)
        }
        if (this.selectedBox.cir3) {
          this.selectedBox.cir3.draggable(false)
          this.selectedBox.cir3.radius(0)
        }
        if (this.selectedBox.cir4) {
          this.selectedBox.cir4.draggable(false)
          this.selectedBox.cir4.radius(0)
        }
      }
    },
    async saveShape (box) {
      if (box) {
        const cords = box.attrs?.points
        if (cords && cords.length === 8) {
          // Save cords of selected box
          let draggedX = box.group?.attrs?.x
          let draggedY = box.group?.attrs?.y
          if (!draggedX) draggedX = 0
          if (!draggedY) draggedY = 0

          const selectedStorage = box.storage
          if (selectedStorage) {
            selectedStorage.T1X = cords[0] + draggedX
            selectedStorage.T1Y = cords[1] + draggedY
            selectedStorage.T2X = cords[2] + draggedX
            selectedStorage.T2Y = cords[3] + draggedY
            selectedStorage.B1X = cords[4] + draggedX
            selectedStorage.B1Y = cords[5] + draggedY
            selectedStorage.B2X = cords[6] + draggedX
            selectedStorage.B2Y = cords[7] + draggedY
            StorageMap.saveStorageMaps(selectedStorage)
            this.$root.$message.showSuccess(this.$t('Saved'))
          }
        }
      }
    },
    pickColor () {
      if (this.selectedBox && this.selectedBox.storage) {
        this.pickColorDialog = true
      }
    },
    colorPicked (color) {
      let hexColor = '#00FF00'
      let dbColor = 1
      switch (color) {
        case 'yellow':
          hexColor = '#FFFF00'
          dbColor = 2
          break
        case 'red':
          hexColor = '#FF0000'
          dbColor = 3
          break
        case 'blue':
          hexColor = '#0000FF'
          dbColor = 4
      }

      if (this.selectedBox?.storage) {
        this.selectedBox.fill(hexColor)
        this.selectedBox.storage.color = dbColor
        this.saveShape(this.selectedBox)
      }
    },
    async changeColor () {
      if (!this.selectedBox) return
      await this.disableMove()
      this.moving = false
      this.pickColor()
    },
    async refreshStorages () {
      this.loading = true
      await this.loadFacilityImage()
      await this.loadStorageMap()
      this.loading = false
    },
    async refreshStoragesClick () {
      await this.disableMove()
      this.moving = false
      this.refreshingPreScale = this.zoomScale
      await this.refreshStorages()
      this.updateMapLayer()
      this.refreshingPreScale = undefined
      this.$root.$message.showSuccess(this.$t('Refreshed'))
    },
    async saveDirtyStorages () {
      if (!this.loading && this.allBoxes) {
        this.allBoxes.forEach(async (box) => {
          if (box.dirty) {
            await this.saveShape(box)
            box.dirty = false
          }
        })
      }
    }
  },
  computed: {
  },
  beforeDestroy () {
  },
  async mounted () {
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }

    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item,
          id: item.Id
        }
      })

      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }
    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }

    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }

    await this.refreshStorages()

    window.addEventListener('resize', this.fitStageIntoParentContainer)

    // console.log('Starting Timer')
    this.getLiveWeightTimer = setInterval(async () => {
      if (!this?.loading) this.saveDirtyStorages()
    }, 5000)
  }
}
</script>
<style>
</style>
